if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartType = document.querySelector('span[data-cartType]')?.getAttribute('data-cartType');
        this.cart = this.resolveCartElement();
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-notification') || this.cartType === 'drawer' || this.cartType === 'minicart') {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Get selected optional services from checkboxes
        const servicesContainer = document.querySelector('[data-services-container]');
        if (servicesContainer) {
          const checkedBoxes = servicesContainer.querySelectorAll('.service-checkbox:checked');

          checkedBoxes.forEach((checkbox, index) => {
            const serviceIndex = index + 1;
            formData.append(`properties[Volitelná služba ${serviceIndex} - Název]`, checkbox.dataset.serviceName || '');
            formData.append(
              `properties[Volitelná služba ${serviceIndex} - Cena]`,
              checkbox.dataset.servicePrice || '0',
            );
            if (checkbox.dataset.serviceDescription && checkbox.dataset.serviceDescription.trim() !== '') {
              formData.append(
                `properties[Volitelná služba ${serviceIndex} - Popis]`,
                checkbox.dataset.serviceDescription,
              );
            }
          });

          if (window.currentServicesSurcharge && window.currentServicesSurcharge.applied > 0) {
            formData.append(
              `properties[_Fixní příplatek za služby]`,
              window.currentServicesSurcharge.applied.toString(),
            );
            formData.append(
              `properties[_Fixní příplatek label]`,
              window.currentServicesSurcharge.label || 'Měsíční příplatek ke splátce:',
            );
          }
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const clearCartAndAdd = (formDataForAdd) => {
          const addConfig = {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formDataForAdd,
          };
          return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .then(() => fetch(window.routes.cart_add_url, addConfig))
            .then((r) => r.json())
            .then(() => {
              window.location = window.routes.cart_url;
            })
            .catch(() => {
              window.location = window.routes.cart_url;
            });
        };

        const buildFormDataForAdd = () => {
          const formDataForAdd = new FormData(this.form);
          if (servicesContainer) {
            servicesContainer.querySelectorAll('.service-checkbox:checked').forEach((checkbox, index) => {
              const i = index + 1;
              formDataForAdd.append(`properties[Volitelná služba ${i} - Název]`, checkbox.dataset.serviceName || '');
              formDataForAdd.append(`properties[Volitelná služba ${i} - Cena]`, checkbox.dataset.servicePrice || '0');
              if (checkbox.dataset.serviceDescription && checkbox.dataset.serviceDescription.trim() !== '')
                formDataForAdd.append(`properties[Volitelná služba ${i} - Popis]`, checkbox.dataset.serviceDescription);
            });
            if (window.currentServicesSurcharge && window.currentServicesSurcharge.applied > 0) {
              formDataForAdd.append(
                'properties[_Fixní příplatek za služby]',
                window.currentServicesSurcharge.applied.toString(),
              );
              formDataForAdd.append(
                'properties[_Fixní příplatek label]',
                window.currentServicesSurcharge.label || 'Měsíční příplatek ke splátce:',
              );
            }
          }
          return formDataForAdd;
        };

        const submitAddToCart = () => {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(false);
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (soldOutMessage) {
                  this.submitButton.setAttribute('aria-disabled', true);
                  this.submitButtonText.classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                  this.error = true;
                  return;
                }
                clearCartAndAdd(buildFormDataForAdd());
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) quickAddModal.hide(true);
              window.location.assign(window.routes.cart_url);
            })
            .catch((error) => {
              console.error(error);
              this.error = true;
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
        };

        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((response) => response.json())
          .then((cart) => {
            const newVariantId = String(formData.get('id') || '');
            const needsReplace =
              Number(cart.item_count) > 0 && cart.items.every((item) => String(item.variant_id) !== newVariantId);

            if (needsReplace) {
              clearCartAndAdd(buildFormDataForAdd());
              return;
            }

            submitAddToCart();
          })
          .catch(() => submitAddToCart());
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.innerHTML = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          const customLabel = this.dataset.addToCartLabel?.trim();
          this.submitButtonText.textContent = customLabel || window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      resolveCartElement() {
        if (this.cartType === 'page') return null;

        const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!cartEl || typeof cartEl.getSectionsToRender !== 'function') return null;

        return cartEl;
      }
    },
  );
}
